<template>
  <!--
    	作者：luoyiming
    	时间：2020-04-26
    	描述：门店-添加门店
    -->
  <div class="product-add">
    <!--form表单-->
    <el-form size="small" ref="form" :model="form" label-width="80px">
      <!--添加门店-->
      <div class="common-form">CDK生成</div>
      <!-- :rules="[{required: true,message: ' '}]" -->
      <el-form-item label="CDK数量" prop="number">
        <el-input type="number" v-model="form.number" placeholder="请输入CDK数量" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="奖励积分" prop="point">
        <el-input type="number" v-model="form.point" placeholder="请输入奖励积分" class="max-w460"></el-input>
      </el-form-item>
      <el-form-item label="商品" prop="product">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="changeProduct"
          v-auth="'/plus/points/product/add'">选择商品</el-button>
      </el-form-item>
      <!--商品信息-->
      <Info v-if="form.product_id != 0"></Info>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--商品选择-->
    <Product :isproduct="isproduct" :productType="productType" :excludeIds="exclude_ids" :islist="false" @closeDialog="closeProductFunc"></Product>
  </div>
</template>

<script>
import PointProductApi from '@/api/pointproduct.js';
import StoreApi from '@/api/store.js';
import Product from '@/components/product/Product.vue';
import Info from './product/info.vue';
export default {
  components: {
    /*产品基本信息*/
    Info,
    /*选择商品*/
    Product
  },
  data() {
    return {
      /*切换菜单*/
      // activeIndex: '1',
      /*form表单数据*/
      form: {
        point: 0,
        number: 0,
        /*商品名称*/
        product_name: '',
        /*商品ID*/
        product_id: 0,
        product_image: '',
        spec_sku_id: ''
      },
      loading: false,
      /*是否打开选择商品*/
      isproduct: false,
      productType:'noRecover1y',
      /*已有的id*/
      exclude_ids: [],
      product_sku: []
    };
  },
  created() {

  },
  provide: function () {
    return {
      form: this.form,
      product_sku: () => this.product_sku,
      type: 'add'
    };
  },
  methods: {
    /*获取商品*/
    getData() {
      let self = this;
      PointProductApi.getProduct(
        {
          product_id: self.form.product_id
        },
        true
      ).then(res => {
        // Object.assign(self.form, res.data.model);
        self.form.product_name = res.data.model.product_name;
        self.form.product_image = res.data.model.product_image;
        var sku = [];
        res.data.model.sku.forEach((item, index) => {
          sku.push({ key: index, label: item.spec_sku_id, value: item.spec_sku_id,stock_num: item.stock_num })
        }) 
        this.product_sku = sku 
        if (this.product_sku.length > 0) {
          self.form.spec_sku_id = this.product_sku[0].value
        }
        self.loading = false;
      });
    },

    /*添加用户*/
    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate((valid) => {
        if (valid) {
          self.loading = true;
          StoreApi.cdkAdd(form, true)
            .then(data => {
              self.loading = false;
              if (data.code == 1) {
                self.$message({
                  message: '恭喜你，添加成功',
                  type: 'success'
                });
                self.$router.push('/appsetting/cdk/index');
              } else {
                self.loading = false;
              }
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });


    },

    /*打开添加*/
    changeProduct(list) {
      this.isproduct = true;
    },

    /*关闭商品选择*/
    closeProductFunc(e) {
      this.isproduct = false;
      if (e.type == 'success') {
        this.addClick(e.params.product_id);
      } else {
        this.form.product_id = 0;
        this.form.product_name = '';
        this.form.spec_sku_id = 0;
      }
    },

    /*添加商品*/
    addClick(product_id) {
      // this.$router.push('/appsetting/cdk/add?product_id=' + product_id);
      this.form.product_id = product_id;
      this.getData();
    },

    /*取消*/
    cancelFunc() {
      this.$router.back(-1);
    }

  }

};
</script>

<style lang="scss" scoped>
.basic-setting-content {}

.product-add {
  padding-bottom: 50px;
}

.img {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/appsetting/cdk/add.vue